import React, { memo, useState } from "react";

// Libraries
import { useField } from "formik";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

export const Input = memo(
  ({ label, labelClass, className, showErrorMsg, type = "text", matchingExpression, ...props }) => {
    const [field, meta, helpers] = useField(props);
    const [isVisible, setIsVisible] = useState(false);
    const { t } = useTranslation();

    const onToggleVisible = () => {
      setIsVisible((state) => !state);
    };

    return (
      <label
        className={clsx("block relative", labelClass, {
          "errors-danger": meta.touched && meta.error,
        })}
      >
        {label}
        <span className="inline-block w-full relative">
          <input
            className={clsx(className, {
              "errors-danger": meta.touched && meta.error,
              "pr-11": type === "password",
            })}
            {...field}
            {...props}
            type={isVisible ? "text" : type}
            onChange={(e) => {
              if (matchingExpression) {
                const target = e.target.value;
                const check = matchingExpression.test(target);
                if (!check) return false;
              }
              helpers.setValue(e.target.value);
            }}
          />
          {type === "password" && (
            <i
              className={clsx("fa-solid absolute right-4 top-1/2 -translate-y-1/2 cursor-pointer", {
                "fa-eye-slash": isVisible,
                "fa-eye ": !isVisible,
              })}
              onClick={onToggleVisible}
            />
          )}
        </span>

        {meta.touched && meta.error && showErrorMsg && (
          <span
            className="text-sm text-error block mt-[5px]"
            dangerouslySetInnerHTML={{ __html: t(meta.error) }}
          />
        )}
      </label>
    );
  }
);

export const TextArea = memo(({ label, labelClass, className, showErrorMsg, ...props }) => {
  const [field, meta] = useField(props);
  const { t } = useTranslation();

  return (
    <label
      className={clsx("block relative", labelClass, {
        "errors-danger": meta.touched && meta.error,
      })}
    >
      {label}
      <textarea
        className={clsx(className, {
          "errors-danger": meta.touched && meta.error,
        })}
        {...field}
        {...props}
      />
      {meta.touched && meta.error && showErrorMsg && (
        <span
          className="text-sm text-error block mt-[5px]"
          dangerouslySetInnerHTML={{ __html: t(meta.error) }}
        />
      )}
    </label>
  );
});

export const Checkbox = memo(({ label, labelClass, className, children, ...props }) => {
  const [field, meta] = useField(props);

  return (
    <label
      className={clsx("flex items-center relative", labelClass, {
        "errors-danger": meta.touched && meta.error,
      })}
    >
      <input
        type="checkbox"
        className={clsx(className, {
          "errors-danger": meta.touched && meta.error,
        })}
        {...field}
        {...props}
      />
      {children}
    </label>
  );
});

export const LabelRequired = ({ title }) => {
  return (
    <span>
      {title} <span className="text-error">*</span>
    </span>
  );
};

export const Label = ({ title, className, required }) => {
  return (
    <span className={className}>
      {title} {required && <span className="text-error">*</span>}
    </span>
  );
};

Input.defaultProps = {
  showErrorMsg: true,
};
